import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

const slides = [
  { image: '/images/HomeSlider14.jpg', eyebrow: 'Northern California', title: 'Garden of Peace Muslim Cemetery', text: 'A nonprofit cemetery project serving Muslims throughout Northern California.', link: '/aboutus', action: 'About Garden of Peace' },
  { image: '/images/HomeSlider11.jpg', eyebrow: 'Our services', title: 'Islamic Burial Services', text: 'Burial services provided in accordance with Islamic practices and local laws.', link: '/services', action: 'View Services' },
  { image: '/images/HomeSlider12.jpg', eyebrow: 'Community support', title: 'Support Garden of Peace', text: 'Donations help us prepare and maintain the cemetery property.', link: '/donate', action: 'Donate' },
];

const HomeBanner = () => (
  <section className="home-hero" aria-label="Garden of Peace highlights">
    <Swiper modules={[Autoplay, EffectFade, Pagination]} effect="fade" loop speed={900} autoplay={{ delay: 6500, disableOnInteraction: false, pauseOnMouseEnter: true }} pagination={{ clickable: true }}>
      {slides.map(slide => (
        <SwiperSlide key={slide.title}>
          <div className="home-hero__slide">
            <img src={slide.image} alt="" aria-hidden="true" />
            <div className="home-hero__shade" />
            <div className="site-container home-hero__content">
              <p className="site-eyebrow site-eyebrow--light">{slide.eyebrow}</p>
              <h1>{slide.title}</h1>
              <p>{slide.text}</p>
              <div className="site-button-row">
                <Link className="site-button site-button--light" to={slide.link}>{slide.action} <span aria-hidden="true">→</span></Link>
                <Link className="site-text-link site-text-link--light" to="/contactus">Contact our team</Link>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  </section>
);
export default HomeBanner;
